
const epsilon = 0.01;

/**
 * Die Y-Positionen von-bis
 */
export default class Fit {

    minCollapse = 0;
    min = 0;
    max = 0;
    maxCollapse = 0;

    translate(offset: number) {
        this.minCollapse += offset;
        this.min += offset;
        this.max += offset;
        this.maxCollapse += offset;
    }

    contains(y) {
        return (this.min-epsilon<=y && y<=this.max+epsilon)
            || (this.minCollapse-epsilon<=y && y<=this.minCollapse+epsilon)
            || (this.maxCollapse-epsilon<=y && y<=this.maxCollapse+epsilon);
    }

}
